import { useEffect, useState } from 'react'
import { RefreshCw } from 'lucide-react'

export function PWAUpdatePrompt() {
  const [needsUpdate, setNeedsUpdate] = useState(false)
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null)

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return

    const handleUpdate = (reg: ServiceWorkerRegistration) => {
      setRegistration(reg)
      setNeedsUpdate(true)
    }

    navigator.serviceWorker.ready.then((reg) => {
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing
        if (!newWorker) return
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            handleUpdate(reg)
          }
        })
      })
    })
  }, [])

  if (!needsUpdate) return null

  const handleRefresh = () => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
    window.location.reload()
  }

  return (
    <div className="fixed top-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:w-80">
      <div className="bg-navy-800 text-white rounded-xl shadow-2xl p-4 flex items-center gap-3">
        <RefreshCw className="w-5 h-5 text-gold-400 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Update available</p>
          <p className="text-navy-200 text-xs">Refresh to get the latest version</p>
        </div>
        <button
          onClick={handleRefresh}
          className="bg-gold-500 hover:bg-gold-600 text-white text-xs font-medium px-3 py-1.5 rounded-lg transition-colors flex-shrink-0"
        >
          Refresh
        </button>
      </div>
    </div>
  )
}
